import { gql } from '@apollo/client'

import { DISH_TYPE_NODE_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_DISH_TYPE_MUTATION = gql`
  mutation setIsCurationEnabledDishType(
    $id: ID!
    $isCurationEnabled: Boolean!
  ) {
    setIsCurationEnabledDishType(
      id: $id
      isCurationEnabled: $isCurationEnabled
    ) {
      ...DishTypeNodeFragment
    }
  }
  ${DISH_TYPE_NODE_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_DISH_TYPE_MUTATION
